// Independent of A-F CCMR — do not import Ccmr/* or write ccmrIndicators*.
import { combineReducers } from 'redux';
import { GET_OUTCOMES_BONUS, UPLOAD_OUTCOMES_BONUS_FILE } from './outcomesBonus.actions';
import { ASYNC_ERROR, ASYNC_FINISH, ASYNC_START } from '../../common/index';

const loadingMsg = (state = '', action) => {
  switch (action.type) {
    case ASYNC_START:
      if (action.model === GET_OUTCOMES_BONUS) {
        return 'Loading Outcomes Bonus ...';
      }
      return state;
    case ASYNC_ERROR:
    case ASYNC_FINISH:
      if (action.model === GET_OUTCOMES_BONUS) {
        return '';
      }
      return state;
    default:
      return state;
  }
};

// The funding aggregate for the currently-loaded grad year, shaped by the
// getOutcomesBonus callable: { aggregate, trend, nearQualifiers }.
const outcomesBonus = (state = {}, action) => {
  switch (action.type) {
    case ASYNC_FINISH:
      if (action.model === GET_OUTCOMES_BONUS) {
        return (action.data && action.data.outcomesBonus) || {};
      }
      return state;
    default:
      return state;
  }
};

// Tracks the file-upload lifecycle for the in-page Dropzone. `seq` increments on every
// settled upload so the component can detect a fresh completion (and fire the funding
// toast) via a prop change, even when the same message repeats.
const initialUpload = { uploading: false, error: null, result: null, seq: 0 };
const upload = (state = initialUpload, action) => {
  switch (action.type) {
    case ASYNC_START:
      if (action.model === UPLOAD_OUTCOMES_BONUS_FILE) {
        return { uploading: true, error: null, result: null, seq: state.seq };
      }
      return state;
    case ASYNC_FINISH:
      if (action.model === UPLOAD_OUTCOMES_BONUS_FILE) {
        return {
          uploading: false,
          error: null,
          result: (action.data && action.data.result) || null,
          seq: state.seq + 1,
        };
      }
      return state;
    case ASYNC_ERROR:
      if (action.model === UPLOAD_OUTCOMES_BONUS_FILE) {
        return {
          uploading: false,
          error: action.desc || 'Upload failed.',
          result: null,
          seq: state.seq + 1,
        };
      }
      return state;
    default:
      return state;
  }
};

export const _reducer = combineReducers({
  loadingMsg,
  outcomesBonus,
  upload,
});

export default 'outcomesBonus.reducers.js';
